import { Injectable } from "@angular/core";
import { Service } from "../service.class";
import { Observable } from "rxjs";
import { PurchasedPackModel } from "../../../shared/entities/purchased-pack.model";

@Injectable({
	providedIn: "root",
})
export class PurchasesService {
	private server_path: string = "/v2/purchasedPacks";

	constructor(private service: Service) {}

	public getPurchasesPacks(client_id: any, paginate: boolean = true): Observable<{ data: PurchasedPackModel[]}> {
		return this.service.apiGetWithoutHeaders(this.server_path, {
			paginate: paginate,
			client: client_id,
		});
	}

	public getPurchasesPacksTrial(isTrial: boolean, paginate: boolean = false): Observable<PurchasedPackModel[]> {
		return this.service.apiGetWithoutHeaders(this.server_path, {
			paginate: paginate,
			isTrial: isTrial,
		});
	}

	public getSubscriptionInvoice(purchasedPackId: string) {
		return this.service.apiGetWithoutHeaders(`${this.server_path}/download/bill/${purchasedPackId}`, null);
	}

	public patchPurchasedPackModelById(purchasedPackModel: PurchasedPackModel, objectToUpdate: any): Observable<PurchasedPackModel> {
		return this.service.apiPatchWithoutHeaders(this.server_path + "/" + purchasedPackModel._id, objectToUpdate);
	}

	public generateBillById(purchasedPackModel: PurchasedPackModel): Observable<PurchasedPackModel> {
		return this.service.apiPatchWithoutHeaders(this.server_path + "/generateBill/" + purchasedPackModel._id, {});
	}

	public checkIfHaveToRenew(body: any): Observable<any> {
		return this.service.apiPostWithoutHeaders("clients/products/renewCheck", body);
	}
}
